import React, { memo } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { LOCATION } from '../../../../common/constants/index.tsx';
import RoundCreateButton from '../../../../common/ui/round-create-button/index.tsx';
import messages from './messages.tsx';

const TEST_ID =
	'navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.create-project-button';

type Props = {
	onClick: () => void;
};
const CreateProjectButton = ({ onClick }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<RoundCreateButton
			label={formatMessage(messages.createProjectLabel)}
			testId={TEST_ID}
			onClick={(_, analyticsEvent) => {
				fireUIAnalytics(analyticsEvent, LOCATION);
				onClick();
			}}
		/>
	);
};

export default memo<Props>(CreateProjectButton);
